import { compareProjectFilesByOrder } from "./projectFileOrder";

type ChapterFileLike = {
  path: string;
  type?: string | null;
  content?: string | null;
  order?: number | null;
  parentPath?: string | null;
};

type SelectionOptions = {
  previousCount?: number;
  fallbackCount?: number;
};

const isUsableChapter = (file: ChapterFileLike) =>
  file.type === "file" &&
  file.path.startsWith("Chapters/") &&
  typeof file.content === "string" &&
  file.content.trim().length > 0;

export const selectRecentChapterFiles = <T extends ChapterFileLike>(
  files: T[],
  activePath?: string | null,
  options: SelectionOptions = {},
) => {
  const previousCount = options.previousCount ?? 2;
  const fallbackCount = options.fallbackCount ?? 3;

  const orderedChapters = [...files].filter(isUsableChapter).sort(compareProjectFilesByOrder);
  if (orderedChapters.length === 0) return [];

  if (activePath) {
    const activeIndex = orderedChapters.findIndex((file) => file.path === activePath);
    if (activeIndex > 0) {
      return orderedChapters.slice(Math.max(0, activeIndex - previousCount), activeIndex);
    }
  }

  return orderedChapters.slice(Math.max(0, orderedChapters.length - fallbackCount));
};
